import { makeAutoObservable } from 'mobx';

class OwnerStore {
  business: string[];

  constructor(business = []) {
    this.business = business;
    makeAutoObservable(this);
  }

  getBusinessInfo(): string {
    return `Owner of business: ${this.business.join(', ')}`;
  }

  setBusiness(business: string[]) {
    this.business = business;
  }
}

export const ownerStore = new OwnerStore();
